import { PortalLaunchDarklyFlags } from '@purepm/purepm-lovs'

// Define the feature flags mapping for all routes
export const ROUTE_FEATURE_FLAGS = {
  // Main Tab routes
  '/lease/*': PortalLaunchDarklyFlags.PORTAL_RENTER_VIEW_LEASE_TAB_ENABLED,
  '/maintenance/*':
    PortalLaunchDarklyFlags.PORTAL_RENTER_MENU_MAINTENANCE_ENABLED,
  '/account/*': PortalLaunchDarklyFlags.PORTAL_RENTER_MENU_ACCOUNT_ENABLED,
  '/payments/*': PortalLaunchDarklyFlags.PORTAL_RENTER_MENU_PAYMENTS_ENABLED,
  '/documents/*':
    PortalLaunchDarklyFlags.PORTAL_RENTER_FUNCTION_UPLOAD_DOCUMENT_ENABLED,
  // Account routes
  '/account/payment-method':
    PortalLaunchDarklyFlags.PORTAL_RENTER_MENU_PAYMENT_OPTIONS_ENABLED,
  '/contact': PortalLaunchDarklyFlags.PORTAL_RENTER_MENU_CONTACT_US_ENABLED,
} as const

// Define main navigation tabs in order of preference for dynamic redirects
export const MAIN_NAV_TABS = [
  '/payments/*',
  '/lease/*',
  '/maintenance/*',
  '/documents/*',
  '/account/*',
] as const

// Define redirect destinations for different route categories
export const ROUTE_REDIRECTS = {
  default: '/',
} as const
